<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Loader from "@/components/_base/Loader";

import Card from "./Card/Index";
import AlmostEmpty from "./AlmostEmpty";
import Empty from "./Empty";
import LoadMore from "./LoadMore";

export default {
  components: {
    Card,
    AlmostEmpty,
    Empty,
    LoadMore,
    Loader
  },

  data() {
    return {
      loading: false
    };
  },

  methods: {
    ...mapActions("orderScheduler", ["loadMoreProfessional"]),

    async handleLoadMoreProfessionals() {
      if (this.loading) return;

      this.loading = true;

      await new Promise(resolve => setTimeout(resolve, 1000));

      this.loadMoreProfessional();

      this.loading = false;
    }
  }
};
</script>

<template>
  <div class="almost-empty">
    <button
      class="btn bg-purple"
      :disabled="loading"
      :class="{'btn--loading': loading}"
      @click="handleLoadMoreProfessionals()"
    >
      <span>Buscar mais profissionais</span>
    </button>
  </div>
</template>

<style scoped>
.almost-empty {
  width: 100%;
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  color: #424242;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/LoadMore.vue